/*
    JS to handle pagination elements for the various different types of archives/search results (MTW, Elastic and Archives).
    Once we have a more unified solution this can be removed or the JS can at least live elsewhere.
 */

jQuery(function($) {
// Show tooltip above triple dots
    var mainBody = $('body');
    mainBody.on('mouseenter mouseleave', '.dots', function() {
        var parentDiv = $(this).closest('.bocss-main-pagination');
        var mainDiv = $(this).position();
        var offsetTop = mainDiv.top - $(".pagination").outerHeight() - 5;
        var offsetLeft = mainDiv.left + ($(this).outerWidth()/2);
        var offsetMargin = -($('.bocss-go-to-navigation--tooltip').outerWidth()/2);

        var newPosition = {
            top: offsetTop,
            left: offsetLeft
        };

        parentDiv.find('.bocss-go-to-navigation--tooltip').css(newPosition);
        parentDiv.find('.bocss-go-to-navigation--tooltip').css('margin-left', offsetMargin);

    });

    // Show tooltip if go to navigation is not open
    mainBody.on('mouseenter', '.dots', function() {
        var parentDiv = $(this).closest('.bocss-main-pagination');

        if (!parentDiv.find(".bocss-go-to-navigation").hasClass('bocss-go-to-navigation__show')) {
            parentDiv.find('.bocss-go-to-navigation--tooltip').show();
        }
    });

    // Hide tooltip
    mainBody.on('mouseleave', '.dots', function() {
        var parentDiv = $(this).closest('.bocss-main-pagination');
        parentDiv.find('.bocss-go-to-navigation--tooltip').hide();
    });

    /**
     * Show/hide go to navigation element
     * @param  jqEvent e A jQuery event object
     */
    mainBody.on("click", '.dots', function(e) {
        var parentDiv = $(this).closest('.bocss-main-pagination');
        parentDiv.find('.bocss-go-to-navigation--tooltip').hide();

        e.stopPropagation();

        var mainDiv = $(this).position();
        var offsetTop = mainDiv.top + $(".pagination").height();
        var offsetLeft = mainDiv.left;

        var newPosition = {
            top: offsetTop,
            left: offsetLeft
        };

        parentDiv.find(".bocss-go-to-navigation").css(newPosition);

        parentDiv.find(".bocss-go-to-navigation").toggleClass("bocss-go-to-navigation__show");

    });

    /**
     * Handle enter key on go to navigation element on archive
     * @param  jqEvent e A jQuery event object
     */
    mainBody.on("keyup", '.bocss-input__text', function(e) {
        var parentDiv = $(this).closest('.bocss-main-pagination');
        if (e.key === 'Enter' || e.keyCode === 13) {
            parentDiv.find('#bocss-go-to-navigation--button__archive').click();
        }
    });

    // Hide the navigation element if user clicks anywhere other than on the element
    mainBody.on("click", function() {

        if ($('.bocss-go-to-navigation').hasClass('bocss-go-to-navigation__show')) {
            $('.bocss-go-to-navigation').removeClass('bocss-go-to-navigation__show');
        }
    });

    /**
     * Stop events from firing when clicking on the navigation element
     * @param  jqEvent e A jQuery event object
     */
    mainBody.on("click", '.bocss-go-to-navigation', function(e) {
        e.stopPropagation();
    });

    mainBody.on('click', '#bocss-go-to-navigation--button__archive', function () {
        var archivePageNum = parseInt($('.bocss-input__text').val());
        var archiveLink = String($('[data-archiveNavigationBase]').attr('data-archivenavigationbase'));
        var maxPages = parseInt($('[data-maxPages]').attr('data-maxPages'));
        var destinationLink = '';
        if (archivePageNum <= maxPages) {
            destinationLink = archiveLink.replace('archiveNavigationBase', archivePageNum) + window.location.search;
        } else {
            destinationLink = archiveLink.replace('archiveNavigationBase', maxPages) + window.location.search;
        }
        if (archivePageNum > 0) {
            window.location.href = destinationLink;
        }
    });

});
